import type { QueryClient } from '@tanstack/react-query';
import {
  fetchShopifyProduct,
  SHOPIFY_PRODUCT_QUERY,
} from 'hooks/product/useShopifyProduct';
import { DEFAULT_COUNTRY_CODE } from 'lib/constants/siteDefaults';

/*
 * INFO: Fetches and caches the relevant Product, then extracts and returns
 * the relevant selling plans. For use when creating a dummy cart.
 */
export const getProductSellingPlans = async (
  queryClient: QueryClient,
  productSlug: string,
) => {
  const shopifyProduct = await queryClient.ensureQueryData({
    queryKey: [SHOPIFY_PRODUCT_QUERY, productSlug, DEFAULT_COUNTRY_CODE],
    queryFn: fetchShopifyProduct,
  });

  if (!shopifyProduct) return null;
  if (!shopifyProduct.availableForSale) return null;

  const dummyCartLineItems = [];

  if ('subscriptions' in shopifyProduct) {
    for (const sub of shopifyProduct.subscriptions) {
      dummyCartLineItems.push({
        merchandiseId: sub.id,
        sellingPlanId: sub.sellingPlan.id,
      });
    }
  }

  /* INFO: (josh) Add the product variants _without_ selling plans to the
   * cart in order to get the standard price with a discount code applied.
   * For use in OTP instances.
   */
  for (const variant of shopifyProduct.variants) {
    dummyCartLineItems.push({
      merchandiseId: variant.id,
    });
  }
  return { id: shopifyProduct.id, lines: dummyCartLineItems };
};
